// extracted by mini-css-extract-plugin
module.exports = {"link":"LinkTo_link__BhmsT","text":"LinkTo_text__fGkrk","backIcon":"LinkTo_backIcon__hhxjC","forwardIcon":"LinkTo_forwardIcon__EsKv_"};